/**
 * @generated SignedSource<<4c3dc5766edf5bf9120aa5ff6399d25b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceLayoutSecondaryContextProvider_viewer$data = {
  readonly itemRead: ReadonlyArray<{
    readonly seller?: {
      readonly isAccessible: boolean | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "PdpRespMarketplaceLayoutSecondaryContextProvider_viewer";
};
export type PdpRespMarketplaceLayoutSecondaryContextProvider_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceLayoutSecondaryContextProvider_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceLayoutSecondaryContextProvider_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceLayoutSecondaryContextProvider_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Seller",
              "kind": "LinkedField",
              "name": "seller",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAccessible",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "fdc0830073396b693bb5bef4f16fcca1";

export default node;
